import { getFeatureConfigs } from '~coreServer/features';

// This featureConfigs object should store all possible features that can be
// enabled/disabled in the application.  In many cases, we'll only primarily
// use one of the methods to toggle a feature, but it's a good practice to
// allow all three methods, as it can make testing easier in the long run.
//
// For example, showRecommendationsOnPdp is something that may initially be A/B
// tested via a cookie, but during development it would be much easier to test
// with lighthouse and sitespeed if a query string could be used, and then when
// the test is complete, it would be easiest to turn on for individual brands
// via an environment variable
//
// Example featureConfig:
//
//     showRecommendationsOnPdp: {
//        // What is the default value if no vars/cookies/queryString's are
//        // specified?
//        default: false,
//        // Is this a multivariate feature config that can be values other
//        // than simply true or false?  Enabling this prevents this module
//        // from coercing values such as "true" or "1" to true and similarly
//        // for "false" and "0" to false
//        multivariate: false,
//        // What environment variable should we look for?
//        envVar: 'SS_SHOW_RECOMMENDATIONS_ON_PDP',
//        // What cookies should we look for?
//        cookies: [
//            'ss-show-recommendations-on-pdp',
//            'SS_PDP_RECS',
//        ],
//        // What queryString should we look for?
//        queryString: 'ss-show-recommendations-on-pdp',
//    }
//
const appFeatureConfigs = {};

// Build the featureConfigs and hard-freeze both the container and each
// individual flag object.  This guarantees the canonical definitions remain
// immutable for the lifetime of the Node process.
const rawFeatureConfigs = getFeatureConfigs(appFeatureConfigs);
const featureConfigs = Object.freeze(
    Object.fromEntries(
        Object.entries(rawFeatureConfigs).map(([key, cfg]) => [key, Object.freeze({ ...cfg })]),
    ),
);

export default featureConfigs;
